import {TITLE_MODEL} from '@app/titles/models/title';
import {ChannelContentModel} from '@app/admin/channels/channel-content-config';
import {NEWS_ARTICLE_MODEL} from '@app/titles/models/news-article';
import {ContentGridProps} from '@app/channels/content-grid/content-grid-layout';
import {Person, PERSON_MODEL} from '@app/titles/models/person';
import {PersonPoster} from '@app/people/person-poster/person-poster';
import {getPersonLink, PersonLink} from '@app/people/person-link';
import {PersonAge} from '@app/people/person-age';
import {NewsArticleGridItem} from '@app/news/news-article-grid-item';
import {
  TitleLandscapeGridItem,
  TitlePortraitGridItem,
} from '@app/channels/content-grid/title-grid-item';
import {useMemo} from 'react';
import {useNavigate} from '@common/utils/hooks/use-navigate';

interface Props {
  item: ChannelContentModel;
  variant?: ContentGridProps['variant'];
  noLazy?: boolean;
}
export function ChannelContentGridItem({item, variant, noLazy}: Props) {
  switch (item.model_type) {
    case TITLE_MODEL:
      return variant === 'landscape' ? (
        <TitleLandscapeGridItem item={item} />
      ) : (
        <TitlePortraitGridItem noLazy={noLazy} item={item} />
      );
    case PERSON_MODEL:
      return <PersonGridItem item={item} />;
    case NEWS_ARTICLE_MODEL:
      return <NewsArticleGridItem article={item} />;
    default:
      return null;
  }
}

interface PersonGridItemProps {
  item: Person;
}
function PersonGridItem({item}: PersonGridItemProps) {
  const navigate = useNavigate();

  const finalUri = useMemo(() => {
    return getPersonLink(item);
  }, [item]);

  return (
    <div>
      <div
        className="iq-cast cursor-pointer"
        onClick={() => navigate(finalUri)}
      >
        <PersonPoster person={item} srcSize="md" size="w-full" />
        <div className="card-img-overlay iq-cast-body">
          <h6 className="cast-title fw-500 whitespace-nowrap">
            <PersonLink
              person={item}
              className="block !overflow-y-clip text-xs font-medium md:text-base"
            />
          </h6>
          <div className="hidden md:block">
            <PersonAge person={item} showRange />
          </div>
        </div>
      </div>
    </div>
  );
}
